import BaseService from '@/services/BaseService'

class AuthenticationService extends BaseService<any> {
  constructor() {
    super('authenticate/')
  }

  public async authenticate(username: string, password: string) {
    delete this.instance.defaults.headers.common[
      BaseService.authorizationHeader
    ]

    return await this.instance.post<any>(this.resourcePath, {
      username,
      password,
    })
  }

  public async authenticateWithAuthorizationCode(code: string) {
    delete this.instance.defaults.headers.common[
      BaseService.authorizationHeader
    ]
    const response = await this.instance.post<any>('autorization-code/', {
      code,
    })
    return response
  }

  public async fetchOfficeLoginUrl() {
    delete this.instance.defaults.headers.common[
        BaseService.authorizationHeader
        ]
    const response = await this.instance.get<any>('office-url/')
    return response.data
  }

  public async info() {
    return await this.instance.get<any>('info/')
  }

  public async validateTokens() {
    return await this.instance.get<any>('/tokens/')
  }
}

export default new AuthenticationService()
